// The one flat form-control recipe for document forms (money, cash entry).
//
// A hairline-bordered field on the card surface — NOT the borderless `bg-input/50` pill the
// base `Input` ships. On dense operator forms the pill reads as a blob and hides where a
// field begins; the hairline keeps every edit target crisp. One focus treatment console-wide:
// `border-ring` + `ring-3 ring-ring/30` (same as input.tsx). Flat throughout — no inset
// shadows, no bevel.
//
// Usable on the shared `Input` (className merge wins) and on raw `<input>`s alike.
export const controlClass =
  "h-8 w-full rounded-md border border-input bg-card px-2.5 text-sm text-foreground outline-none " +
  "transition-[color,box-shadow] duration-200 placeholder:text-muted-foreground " +
  "focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/30 " +
  "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 " +
  "aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20"
